// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"ie","image":"if","contentContainer":"ih","mainText":"ii","subText":"ij","counter":"ik"};